export enum DrawAction {
  start = "start",
  move = "move",
  end = "end"
}
